exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-core-video-player-control .btn-pause{margin-left:20px}.vue-core-video-player-control .btn-pause svg{width:15px}.vue-core-video-player-control .btn-play{margin-left:20px}.vue-core-video-player-control .btn-play svg{width:16px}", ""]);

// exports
